module.exports = __webpack_public_path__ + "img/5.cf102c81.jpg";